module.exports = __webpack_public_path__ + "static/img/12.1b93452.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/zh/12.png
// module id = Gvfn
// module chunks = 0